var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup", class: { visible: _vm.visible } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", {
            staticClass: "close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "header-title text-center" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("footer.cancelSubscription.title")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        !_vm.success
          ? _c("div", { staticClass: "form-wrapper" }, [
              _c("form", { attrs: { id: "cancel-subscription-form" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  attrs: {
                    type: "email",
                    required: "",
                    placeholder: _vm.$t(
                      "footer.cancelSubscription.emailPlaceholder"
                    )
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      },
                      _vm.validate
                    ]
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.last4,
                      expression: "last4"
                    }
                  ],
                  attrs: {
                    type: "text",
                    maxlength: "4",
                    required: "",
                    placeholder: _vm.$t(
                      "footer.cancelSubscription.cardPlaceholder"
                    )
                  },
                  domProps: { value: _vm.last4 },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.last4 = $event.target.value
                      },
                      _vm.validate
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: { loading: _vm.loading },
                    attrs: {
                      type: "submit",
                      disabled: !_vm.formValid || _vm.loading
                    },
                    on: { click: _vm.cancel }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("footer.cancelSubscription.cancel")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.error
                  ? _c("p", { staticClass: "error" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("footer.cancelSubscription.errorToCancel")
                        )
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "note" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("footer.cancelSubscription.caption[0]")) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "note" }, [
                  _vm._v(
                    _vm._s(_vm.$t("footer.cancelSubscription.caption[1]")) +
                      " " +
                      _vm._s(_vm.support_email)
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.success
          ? _c("div", { staticClass: "form-wrapper" }, [
              _c("form", [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("footer.cancelSubscription.subscriptionCanceled")
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "button", on: { click: _vm.close } },
                  [_vm._v(_vm._s(_vm.$t("footer.cancelSubscription.close")))]
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }